import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfPlusFolderIconProps {
  fillColor: any;
}

/**
 * Component diaplays pin control icon
 * @param props -CcfPlusFolderIconProps
 * @returns pin control svg icon
 * @example <CcfPlusFolderIcon/>
 */
export function CcfPlusFolderIcon(props: CcfPlusFolderIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.16667 17.5C3.70833 17.5 3.31583 17.3367 2.98917 17.01C2.6625 16.6833 2.49945 16.2911 2.5 15.8333V4.16667C2.5 3.70833 2.66333 3.31583 2.99 2.98917C3.31667 2.6625 3.70889 2.49945 4.16667 2.5H11.6667V4.16667H4.16667V15.8333H15.8333V8.33333H17.5V15.8333C17.5 16.2917 17.3367 16.6842 17.01 17.0108C16.6833 17.3375 16.2911 17.5006 15.8333 17.5H4.16667ZM6.66667 14.1667V12.5H13.3333V14.1667H6.66667ZM6.66667 11.6667V10H13.3333V11.6667H6.66667ZM6.66667 9.16667V7.5H13.3333V9.16667H6.66667ZM14.1667 7.5V5.83333H12.5V4.16667H14.1667V2.5H15.8333V4.16667H17.5V5.83333H15.8333V7.5H14.1667Z"
          fill={props?.fillColor ? props?.fillColor : '#3F5C69'}
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfPlusFolderIcon;
